import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Card as MuiCard,
  Stack,
  CssBaseline
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AppTheme from '../shared-theme/AppTheme'; // Adjust path if needed
import API_BASE_URL from '../config'; 

const ResetContainer = styled(Stack)(({ theme }) => ({
    height: '100dvh',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: -1,
      inset: 0,
      backgroundImage: 'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    },
}));

const Card = styled(MuiCard)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: '450px',
  width: '100%',
  margin: 'auto',
}));

export default function PasswordResetConfirm(props) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/user/password/reset/confirm/`, {
        uidb64,
        token,
        password,
        confirm_password: confirmPassword,
      });
      setSuccess('Your password has been reset successfully! Redirecting to login...');
      setTimeout(() => navigate('/sign-in'), 3000); // Redirect to sign-in page
    } catch (err) {
      setError('Invalid or expired link. Please try resetting your password again.');
      console.error('Password reset confirmation failed:', err);
    }
  };

  return (
    <AppTheme {...props}>
        <CssBaseline />
        <ResetContainer>
            <Card>
                <Typography component="h1" variant="h5" sx={{ mb: 2, textAlign: 'center' }}>
                    Set New Password
                </Typography>
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                {success && <Alert severity="success" sx={{ width: '100%', mb: 2 }}>{success}</Alert>}
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="New Password"
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="confirmPassword"
                        label="Confirm New Password"
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Reset Password
                    </Button>
                </Box>
            </Card>
        </ResetContainer>
    </AppTheme>
  );
}